import {FormField} from 'shells/form/form-field';
import {Stack} from 'shells/layout/stack/stack';
import type {SavedSettingToastState} from 'shells/saved-setting-toast/saved-setting-toast';

import {PipelineSelectPicker} from '../../../../core/form/fields/pipeline-select-picker';

import type {SaveStateKey} from './consts';
import {ToggleSection} from './toggle-section';

interface Props {
    labelContent: string;
    description: string;
    isOn: boolean;
    onToggle: () => void;
    toastState: SavedSettingToastState;
    savingToastKey: SaveStateKey | null | undefined;
    toggleSaveKey: SaveStateKey;
    pipelineSaveKey: SaveStateKey;
    pipeline: string;
    onSelectPipeline: (newPipeline: string) => void;
    showPipeline: boolean;
    pipelineFieldId?: string;
    pipelineNoMargin?: boolean;
    children?: React.ReactNode;
    isDisabled?: boolean;
}

export function LeadCreationToggleSection(props: Props) {
    const {pipelineFieldId = 'pipeline'} = props;

    const pipelineField = props.showPipeline ? (
        <FormField
            innerId={pipelineFieldId}
            label='Pipeline'
            saveToastState={
                props.savingToastKey === props.pipelineSaveKey ? props.toastState : 'initial'
            }
            noMargin={props.pipelineNoMargin ?? false}
        >
            <PipelineSelectPicker
                selectedPipeline={props.pipeline}
                onSelectPipeline={(newPipeline) => {
                    if (newPipeline === props.pipeline) {
                        return;
                    }
                    props.onSelectPipeline(newPipeline);
                }}
                autoSelectAutoDistribute={true}
                isDisabled={props.isDisabled}
            />
        </FormField>
    ) : undefined;

    let content = null;
    if (props.showPipeline) {
        content = props.children ? (
            <Stack spacing={16}>
                {pipelineField}
                {props.children}
            </Stack>
        ) : (
            pipelineField
        );
    }

    return (
        <ToggleSection
            labelContent={props.labelContent}
            description={props.description}
            isOn={props.isDisabled ? false : props.isOn}
            state={props.savingToastKey === props.toggleSaveKey ? props.toastState : 'initial'}
            onChange={props.onToggle}
            isDisabled={props.isDisabled}
        >
            {content}
        </ToggleSection>
    );
}
